import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("ALL");
  const [dateRange, setDateRange] = useState("30D");

  const loadBrands = async () => {
    try {
      const { data } = await api.get("/brands");
      setBrands(data);
    } catch (e) { /* ignore */ }
  };

  const bootstrap = async () => {
    const token = localStorage.getItem("scr_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await loadBrands();
    } catch (e) {
      localStorage.removeItem("scr_token");
      setUser(false);
    }
  };

  useEffect(() => { bootstrap(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("scr_token", data.access_token);
    setUser(data.user);
    await loadBrands();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("scr_token");
    setUser(false);
    setBrands([]);
  };

  return (
    <AppCtx.Provider value={{ user, brands, selectedBrand, setSelectedBrand, dateRange, setDateRange, login, logout, loadBrands }}>
      {children}
    </AppCtx.Provider>
  );
}
